import PrivacyPolicyPage from "src/pages/Legal/PrivacyPolicy";
export default PrivacyPolicyPage;
